import React, { useEffect, useRef } from 'react';
import { Modal, Button, Tooltip, Popconfirm, Row, Col } from 'antd';
import { InfoCircleOutlined } from '@ant-design/icons';
import './index.scss';
import { UpgradeDetail } from '@/utils';
import { MapUpdaterStatus } from '@/utils/constant';
interface Props {
  visible: boolean;
  title: string;
  handleClose: AnyFunc;
  updateDetail: UpgradeDetail;
  open: boolean;
  setOpen: AnyFunc;
  openMapUpdateDetail: AnyFunc;
  getMapUpdateDetail: AnyFunc;
  confirmSilent: AnyFunc;
}

const UpdateDetailModal = (props: Props) => {
  const {
    visible,
    handleClose,
    title,
    updateDetail,
    open,
    setOpen,
    openMapUpdateDetail,
    getMapUpdateDetail,
    confirmSilent,
  } = props;

  const timerRef = useRef<any>(null);

  useEffect(() => {
    if (visible) {
      if (timerRef.current) {
        clearInterval(timerRef.current);
      }
      timerRef.current = setInterval(() => {
        getMapUpdateDetail();
      }, 30000);
    }

    return () => {
      clearInterval(timerRef.current);
    };
  }, [visible]);

  return (
    <>
      <div className='update-detail-btn' onClick={openMapUpdateDetail}>
        [升级详情]
      </div>
      <Modal
        maskClosable={false}
        visible={visible}
        onCancel={handleClose}
        title={title}
        footer={null}
        className='update-detail-modal'
      >
        <Row>
          <Col span={4}>版本</Col>
          <Col span={17}>{updateDetail?.version}</Col>
          <Col span={4}>阶段</Col>
          <Col span={17}>
            {updateDetail?.progressTypeName}
            {updateDetail.progressType === MapUpdaterStatus.DOWNLOADING ? (
              <>
                <Popconfirm
                  overlayClassName='confirm-silent-container'
                  title={
                    <i style={{ color: 'white' }}>
                      静默下载即后台下载，车辆启动后将使用原地图版本运行，请确认是否转为静默下载。
                    </i>
                  }
                  open={open}
                  onConfirm={() => {
                    confirmSilent();
                  }}
                  onCancel={() => {
                    setOpen(false);
                  }}
                >
                  <Button
                    type='primary'
                    onClick={() => {
                      setOpen(true);
                    }}
                    style={{
                      marginLeft: '5px',
                    }}
                  >
                    转为静默下载
                  </Button>{' '}
                </Popconfirm>
                <Tooltip title='静默下载即后台下载，车辆启动后将使用原地图版本运行，不会打扰用户正常使用车辆。'>
                  <InfoCircleOutlined />
                </Tooltip>
              </>
            ) : (
              <></>
            )}
          </Col>
          <Col span={4}>进度</Col>
          <Col span={6}>
            {updateDetail.progressType === MapUpdaterStatus.DOWNLOADING
              ? updateDetail?.downloadStep || '--'
              : updateDetail.progressType === MapUpdaterStatus.UPGRADE
                ? updateDetail?.upgradeStep || '--'
                : 0}
            %
          </Col>
          <Col span={5}>预计剩余时间</Col>
          <Col span={8}>{updateDetail?.estimatedCompletionTime || '--'}</Col>
        </Row>
      </Modal>
    </>
  );
};

export default UpdateDetailModal;
